import envs from "../envs";

export const mapaCondicoesGerais =
  "/AreaAberta/Capitalizacao/CondicoesGerais/Condicoes-Gerais.json";

export const guiaSorteios = `${envs.hostStaticCdn}/AreaAberta/Capitalizacao/Guias/guia_como_encontrar_o_numero_do_plano.pdf`;

export const home = `/paravoce/capitalizacao`;
export const novaAreaCapitalizacao = `${envs.hostCaixaSeguridade}/Paginas/Capitalizacao.aspx`;

export const areaLogada = `${envs.hostAreaLogada}/login/caixa-seguradora`;
